import axiosWrapper from './axiosWrapper';
import { getNotes } from '../cache/dataClient';
import cacheSync from '../cache/cacheSync';

const noteService = {
  // Get all notes for a project (offline-first)
  async getNotes(projectId, options = {}) {
    const { useCache = true, featureContext, parentType, parentId } = options;

    // Try dataClient first (uses cache when offline)
    const result = await getNotes(projectId, {
      useCache,
      featureContext,
      parentType,
      parentId,
    });
    if (result.error && !result.fromCache) {
      return { data: null, error: result.error };
    }

    // Return in format expected by existing code
    return {
      data: { notes: result.data || [] },
      error: null,
      fromCache: result.fromCache,
    };
  },

  // Get a single note by ID
  async getNoteById(projectId, noteId) {
    const response = await axiosWrapper({
      method: 'get',
      path: `projects/${projectId}/notes/${noteId}`,
    });
    return response;
  },

  // Create a new note
  async createNote(projectId, noteData) {
    const response = await axiosWrapper({
      method: 'post',
      path: `projects/${projectId}/notes`,
      data: noteData,
    });
    // Update cache after successful creation
    if (!response.error) {
      cacheSync.syncAfterMutation('notes', response, 'create').catch((err) => {
        console.warn('[noteService] Error updating cache after create:', err);
      });
    }
    return response;
  },

  // Update an existing note
  async updateNote(projectId, noteId, noteData) {
    const response = await axiosWrapper({
      method: 'put',
      path: `projects/${projectId}/notes/${noteId}`,
      data: noteData,
    });
    // Update cache after successful update
    if (!response.error) {
      cacheSync.syncAfterMutation('notes', response, 'update').catch((err) => {
        console.warn('[noteService] Error updating cache after update:', err);
      });
    }
    return response;
  },

  // Delete a note
  async deleteNote(projectId, noteId) {
    const response = await axiosWrapper({
      method: 'delete',
      path: `projects/${projectId}/notes/${noteId}`,
    });
    // Update cache after successful delete
    if (!response.error) {
      cacheSync.syncAfterMutation('notes', { id: noteId }, 'delete').catch((err) => {
        console.warn('[noteService] Error updating cache after delete:', err);
      });
    }
    return response;
  },
};

export default noteService;
